/**
 * useCanonical — Set/update the canonical <link> tag in document.head.
 *
 * Workaround for react-helmet-async@2.0.5 which silently drops <link> tags
 * under React 19. Titles and meta still emit correctly via Helmet, but link
 * emission requires this direct DOM manipulation.
 *
 * Usage:
 *   useCanonical('https://validatedboat.fr/analyse-annonce-bateau');
 */
import { useEffect } from 'react';

export function useCanonical(href) {
  useEffect(() => {
    if (!href || typeof document === 'undefined') return undefined;
    let link = document.querySelector('link[rel="canonical"]');
    const created = !link;
    if (!link) {
      link = document.createElement('link');
      link.setAttribute('rel', 'canonical');
      document.head.appendChild(link);
    }
    const previous = link.getAttribute('href');
    link.setAttribute('href', href);

    return () => {
      // Cleanup: if we created the link, remove it. Otherwise restore prev href.
      if (created) {
        link.remove();
      } else if (previous !== null) {
        link.setAttribute('href', previous);
      }
    };
  }, [href]);
}

export default useCanonical;
